import { DefaultFontsEnum } from '../enums/default-fonts.enum';

export const textStyleFontDropdownOptions = [
    // first element will be used as default
    {
        label: 'Font.arial',
        value: DefaultFontsEnum.Arial
    },
    {
        label: 'Font.comicSans',
        value: DefaultFontsEnum.Comic_Sans
    },
    {
        label: 'Font.courierNew',
        value: DefaultFontsEnum.Courier_New
    },
    {
        label: 'Font.georgia',
        value: DefaultFontsEnum.Georgia
    },
    {
        label: 'Font.helvetica',
        value: DefaultFontsEnum.Helvetica
    },
    {
        label: 'Font.lucida',
        value: DefaultFontsEnum.Lucida
    },
    {
        label: 'Font.tahoma',
        value: DefaultFontsEnum.Tahoma
    },
    {
        label: 'Font.times',
        value: DefaultFontsEnum.Times
    },
    {
        label: 'Font.trebuchet',
        value: DefaultFontsEnum.Trebuchet_MS
    },
    {
        label: 'Font.verdana',
        value: DefaultFontsEnum.Verdana
    },
];
